/**
 * Multi-brand (white-label) — tipos.
 * Default de segurança: qualquer ausência → `platform`.
 */

export type BrandKey = 'platform' | 'zuadaria';

export type BrandLandingTemplate = 'events_bio' | 'comedy_club';

export type BrandEventCategory = { value: string; label: string };

export type BrandFormStep = { label: string; description: string };

export interface BrandConfig {
  key: BrandKey;
  displayName: string;
  logoUrl: string;
  favicons: Array<{ rel: string; type?: string; href: string; sizes?: string }>;
  documentTitle: string;
  og: {
    title: string;
    description: string;
    image: string;
    url: string;
    siteName: string;
  };
  landingTemplate: BrandLandingTemplate;
  publicPage: {
    flatPage: boolean;
    pageBg: string;
    pageBgDeep: string;
    text: string;
    textSoft: string;
    heading: string;
    accent: string;
    accentSoft: string;
    border: string;
    surface: string;
    surfaceSoft: string;
    cardShadow: string;
    ctaStart: string;
    ctaEnd: string;
    ctaShadow: string;
  };
  copy: {
    auth: {
      loginTitle: string;
      loginSubtitle: string;
      footerShort: string;
      footerWide: string;
      /** Texto após “mesmo e-mail de login” na tela de recuperar senha. */
      forgotPasswordHint: string;
    };
    chrome: {
      sidebarTitle: string;
      sidebarSubtitle: string;
      footerCopyright: string;
      showAcutisQuote: boolean;
      showSupportEmail: boolean;
      supportEmail?: string;
      /** Handle do Instagram sem @ (ex.: meusacramento). */
      supportInstagram?: string;
    };
    eventForm: {
      titlePlaceholder: string;
      slugPlaceholder: string;
      slugHelper: string;
      locationPlaceholder: string;
      descriptionPlaceholder: string;
      contactEmailPlaceholder: string;
      promoLinkPlaceholder: string;
      categories: BrandEventCategory[];
      /** Valores antigos → categoria atual (ex.: open_mic → standup). */
      categoryAliases?: Record<string, string>;
      steps: BrandFormStep[];
      registrationSettingsTitle: string;
      registrationSettingsHelp: string;
      registrationDeadlineLabel: string;
    };
    home: {
      chip: string;
      title: string;
      titleAccent: string;
      subtitle: string;
      ctaExplore: string;
      ctaSecondary: string;
      ctaSecondaryHref: string;
      eventsChip: string;
      eventsTitle: string;
      eventsSubtitle: string;
      eventsCountLabel: string;
      emptyTitle: string;
      emptySubtitle: string;
      fallbackCover: string;
    };
  };
}

export const BRAND_HOST_MAP: Record<string, BrandKey> = {
  'zuadaria.com.br': 'zuadaria',
  'www.zuadaria.com.br': 'zuadaria',
  'zuadaria.localhost': 'zuadaria',
};

export const BRAND_KEYS: BrandKey[] = ['platform', 'zuadaria'];

export function isBrandKey(value: unknown): value is BrandKey {
  return value === 'platform' || value === 'zuadaria';
}
